import {
  GetSiniestroDocumentsApi,
  GetSiniestroDocumentPDFApi,
  GetDocument,
} from '../../../services/DocumentosApi';
import { openCloseToast } from '../../Global/actions';
// import validacion from "../../../helpers/validaciones"; //,
import trace from '../../../helpers/trace';

export const ListaTipoPrestacionEconomica = [
  {
    IdTipoPrestacionEconomica: 'S0',
    DescripcionPrestacionEconomica: 'SUBSIDIO DIRECTO',
  },
  {
    IdTipoPrestacionEconomica: 'S1',
    DescripcionPrestacionEconomica: 'SUBSIDIO EMPRESA EN CONVENIO',
  },
  {
    IdTipoPrestacionEconomica: 'S2',
    DescripcionPrestacionEconomica: 'SUBSIDIO INSTITUCION PUBLICO',
  },
  {
    IdTipoPrestacionEconomica: 'I0',
    DescripcionPrestacionEconomica: 'INDEMNIZACIONES',
  },
  {
    IdTipoPrestacionEconomica: 'P0',
    DescripcionPrestacionEconomica: 'PENSION POR ACCIDENTE',
  },
  {
    IdTipoPrestacionEconomica: 'PT',
    DescripcionPrestacionEconomica: 'PENSION POR TRAMITE',
  },
  {
    IdTipoPrestacionEconomica: 'P3',
    DescripcionPrestacionEconomica: 'PENSION POR SUPERVIVENCIA',
  },
  {
    IdTipoPrestacionEconomica: 'C0',
    DescripcionPrestacionEconomica: 'CONCURRENCIA PENSIONES',
  },
  {
    IdTipoPrestacionEconomica: 'C1',
    DescripcionPrestacionEconomica: 'CONCURRENCIA INDEMNIZACION',
  },
  {
    IdTipoPrestacionEconomica: 'C2',
    DescripcionPrestacionEconomica: 'CONCURRENCIA SUPERVIVENCIA',
  },
];

export const loading = (isLoading) => ({
  type: 'LOADING_DOCUMENTS',
  isLoading,
});

export const success = (isSuccess) => ({
  type: 'SUCCESS_DOCUMENTS',
  isSuccess,
});

export const error = (isError) => ({
  type: 'ERROR_DOCUMENTS',
  isError,
});

export const setDescription = (description) => ({
  type: 'SET_DESCRIPTION',
  description,
});

export const viewDocumentos = (view, data) => ({
  type: 'VIEW_DOCUMENTOS',
  view,
  data,
});

export const setLastSiniestro = (siniestro) => ({
  type: 'SET_LAST_SINIESTRO',
  siniestro,
});

export const setDocumentSiniestro = (listDocuments) => ({
  type: 'SET_DOCUMENT_SINIESTRO',
  listDocuments,
});

const handleTagManager = (dispatch, description, postTagManager, isSuccess) => {
  if (description) {
    switch (description) {
      case 'RECA':
        postTagManager(
          {
            label: 'Clic Btn: Documentos - RECA',
            response: isSuccess ? 'Éxito' : 'Error',
          },
          dispatch,
        );
        break;
      case 'Certificado de Atención':
        postTagManager(
          {
            label: 'Clic Btn: Documentos - Certificado de atención',
            response: isSuccess ? 'Éxito' : 'Error',
          },
          dispatch,
        );
        break;
      case 'Certificado de ingreso':
        postTagManager(
          {
            label: 'Clic Btn: Documentos - Certificado de ingreso',
            response: isSuccess ? 'Éxito' : 'Error',
          },
          dispatch,
        );
        break;
        case 'Certificado de Reingreso':
          postTagManager(
            {
              label: 'Clic Btn: Documentos - Certificado de reingreso',
              response: isSuccess ? 'Éxito' : 'Error',
            },
            dispatch,
          );
          break;
      case 'Formulario ALME.':
        postTagManager(
          {
            label: 'Clic Btn: Documentos - Certificado de alta médica',
            response: isSuccess ? 'Éxito' : 'Error',
          },
          dispatch,
        );
        break;
      case 'Certificado Alta inmediata':
        postTagManager(
          {
            label: 'Clic Btn: Documentos - Certificado alta inmediata',
            response: isSuccess ? 'Éxito' : 'Error',
          },
          dispatch,
        );
        break;
      case 'Certificado de alta diferida':
        postTagManager(
          {
            label: 'Clic Btn: Documentos - Certificado de alta diferida',
            response: isSuccess ? 'Éxito' : 'Error',
          },
          dispatch,
        );
        break;
      case 'Certificado Orden Reposo':
        postTagManager(
          {
            label: 'Clic Btn: Documentos - Orden de reposo',
            response: isSuccess ? 'Éxito' : 'Error',
          },
          dispatch,
        );
        break;
      case 'Certificado de derivación de paciente (Artículo 77 bis)':
        postTagManager(
          {
            label: 'Clic Btn: Documentos - Certificado derivación de paciente',
            response: isSuccess ? 'Éxito' : 'Error',
          },
          dispatch,
        );
        break;
      case 'Certificado de término de reposo laboral':
        postTagManager(
          {
            label: 'Clic Btn: Documentos - Certificado de término de reposo laboral',
            response: isSuccess ? 'Éxito' : 'Error',
          },
          dispatch,
        );
        break;
      case 'Denuncia individual de accidente del trabajo (DIAT) de la empresa':
        postTagManager(
          {
            label: 'Clic Btn: Documentos - DIAT empresa',
            response: isSuccess ? 'Éxito' : 'Error',
          },
          dispatch,
        );
        break;
      case 'Denuncia individual de Enfermedad Profesional(DIEP) de la empresa':
        postTagManager(
          {
            label: 'Clic Btn: Documentos - DIEP empresa',
            response: isSuccess ? 'Éxito' : 'Error',
          },
          dispatch,
        );
        break;
      case 'Denuncia individual de accidente del trabajo (DIAT) del trabajador':
        postTagManager(
          {
            label: 'Clic Btn: Documentos - DIAT trabajador',
            response: isSuccess ? 'Éxito' : 'Error',
          },
          dispatch,
        );
        break;
      case 'Denuncia individual de Enfermedad Profesional(DIEP) del trabajador':
        postTagManager(
          {
            label: 'Clic Btn: Documentos - DIEP trabajador',
            response: isSuccess ? 'Éxito' : 'Error',
          },
          dispatch,
        );
        break;
      case 'Testigos y antecedentes a presentar':
        postTagManager(
          {
            label: 'Clic Btn: Documentos - Testigos y accidentes',
            response: isSuccess ? 'Éxito' : 'Error',
          },
          dispatch,
        );
        break;
        case 'Certificado Alta en el día/Adm':
          postTagManager(
            {
              label: 'Clic Btn: Documentos - Certificado alta en el día',
              response: isSuccess ? 'Éxito' : 'Error',
            },
            dispatch,
          );
          break;
      default:
        break;
    }
  }
};

export const doGetDocumentBySiniestro = (Id, data, origen = null) => async (dispatch) => {
  dispatch(loading(true));
  const toast = {};
  try {
    if (origen === null) {
      const request = await GetSiniestroDocumentsApi(Id, data.tipoBusqueda);
      if (request.status === 200) {
        const result = await request.json();

        if (result.Documentos.length > 0) {
          if (origen === null) {
            dispatch(setDocumentSiniestro(result.Documentos));
            dispatch(viewDocumentos(true, data));
          }
        } else {
          toast.isToastOpen = true;
          toast.msgToast = 'Siniestro sin documentos';
          toast.typeStyle = 'warning';
          toast.displayTime = 5000;
          dispatch(openCloseToast(toast));
        }
      }
    }
    if (origen === 'worker') {
      const response = await GetSiniestroDocumentPDFApi(Id);
      const file = new Blob([response], { type: 'application/pdf' });
      const objUrl = window.URL.createObjectURL(file);
      window.open(objUrl);
    }
  } catch (e) {
    toast.isToastOpen = true;
    toast.msgToast = 'Error de conexión, intente mas tarde';
    toast.typeStyle = 'error';
    toast.displayTime = 5000;
    dispatch(openCloseToast(toast));
  }
  dispatch(loading(false));
};

export const doOpenDocument = (DocumentId, Description, postTagManager) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const response = await GetDocument(DocumentId);
    const file = new Blob([response], { type: 'application/pdf;base64' });
    const objUrl = window.URL.createObjectURL(file);
    window.open(objUrl);
    dispatch(success(true));
    handleTagManager(dispatch, Description, postTagManager, true)
  } catch (e) {
    console.log(e);
    dispatch(error(true));
    handleTagManager(dispatch, Description, postTagManager, true)
 
  }
  dispatch(loading(false));
};


